module.exports = {
    model: {
        icon: '',
        colors: {}
    },

    events: {
        click(event){
            const self = event.data.component
            const registerSecret = self.model.registerSecret
            self.locate('<< base_tabStrip_tabStrip', tabStrip => {
                tabStrip.focusTab(registerSecret)
            })
        }
    },

    handlers: [{
        name: 'onTabActivate',
        componentClass: 'templates_core_tabStrip_tab',
        handle: function(callerComponent){
            if(callerComponent.config.isMainTab){
                this.model.colors = callerComponent.resourceData.colors || {}
                this.model.icon = callerComponent.resourceData.aliasIcon || callerComponent.resourceData.icon || ''
                this.model.registerSecret = callerComponent.config.registerSecret
                this.refresh()
            }
        }
    }]
}